import type { AnalyticsPanel } from '../api/client.js';

/**
 * Pure helpers for the Analytics page, kept out of the `.tsx` so they are testable — the admin's
 * vitest config ships no jsdom, so anything reachable only through a rendered component is not.
 * Same split as `dashboard.model.ts` and `quantityOffers.model.ts`.
 */

/**
 * Has anything actually gone through a quantity offer in this range?
 *
 * Drives whether the "…will appear once offer impressions are tracked" note is shown. The note
 * exists to explain three zeros — that they are an empty range and not a broken integration. Once
 * the merchant has real numbers it explains nothing, so it stops being informative and becomes a
 * line of grey text sitting under them.
 *
 * All three counters, not just `selections`: an offer can be selected without discounting (a 0%
 * tier), and a range can carry revenue from an offer whose `selections` count the backend attributes
 * elsewhere. Any one of them being non-zero means there is something on screen worth reading.
 */
export function hasOfferActivity(qo: AnalyticsPanel['quantityOffers']): boolean {
  return qo.selections > 0 || qo.revenueContribution > 0 || qo.discountGiven > 0;
}
